import '@/scss/main.scss'

import VueMeta from 'vue-meta';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app';
import 'firebase/auth';

import Toasted from 'vue-toasted';

import persistentState from 'vue-persistent-state'

const config = {
  
  apiKey: "AIzaSyDQom0MarNJ-pe2AwOCixtfqIbz3uzgVdY",
  databaseURL: "https://rsdm-stripe-portal.firebaseapp.com",
  authDomain: "rsdm-stripe-portal.firebaseapp.com",
  projectId: "rsdm-stripe-portal",
  storageBucket: "rsdm-stripe-portal.appspot.com",
  messagingSenderId: "821475000150",
  appId: "1:821475000150:web:8a792cfa6858ef5673a0f7"
};

let initialState = {
  persisted: {
    str: 'dead'
  }
}

firebase.initializeApp(config);

Vue.use(Toasted)

Vue.use(VueMeta);

Vue.use(persistentState, initialState)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
